const EMAIL_DELIVERY_FAILURE = /(?:\b(?:could(?:n't| not)|cannot|unable|failed|failure)\b[\s\S]{0,60}\b(?:send|deliver)[\s\S]{0,60}\b(?:email|mail)\b)|(?:\b(?:email|mail)\b[\s\S]{0,60}\b(?:could(?:n't| not)|cannot|unable|failed|failure|not\s+(?:be\s+)?(?:sent|delivered))\b)/i;

/**
 * Classifies a successful HTTP response as an email-delivery failure only when used by an
 * email-producing endpoint. It deliberately does not run globally for unrelated API responses.
 */
export function emailDeliveryFailure(data, fallback = "The email could not be sent.") {
  if (!data || typeof data !== "object") return null;
  const messages = [data.emailError, data.emailMessage, data.message, data.error?.message]
    .filter((value) => typeof value === "string" && value.trim());
  const failed = data.emailSent === false || data.status === "EMAIL_FAILED" || Boolean(data.emailError)
    || messages.some((message) => EMAIL_DELIVERY_FAILURE.test(message));
  return failed ? messages[0] || fallback : null;
}
